import { handleActions } from 'redux-actions';

import * as types from './actionTypes';
import { tabs } from './constants';

const initialState = tabs.CAMPAIGN;

const reducerMap = {
	[types.SET_ACTIVE_TAB]: (state, { payload }) => payload.activeTab,
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
